import { Routes, RouterModule, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeclarationService } from '../dashboard/services/declaration.service';
// import {FormsData} from '../dashboard/models/DashboardModel'
import { SharingService } from '../shared/shared.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomSpinnerComponent } from '../../shared/components/custom-spinner/custom-spinner.component';
import { exportFile } from 'src/app/shared/utils/export-file.function';
import { environment } from 'src/environments/environment';
//import { writeFileSync } from 'fs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  customSpinnerComponent = CustomSpinnerComponent;
  clientNo: any;
  fomsData: any = [];
  cachedFormsData: any = [];
  FormsDeclarationsData: any;
  Year: any;
  form1Data: any;
  form2Data: any;
  form3Data: any;
  form4Data: any;
  form5Data: any;
  form6Data: any;
  noIntervenant: string;
  LangueClient: string;
  Aff_check: string;
  rowData = [];
  objectData = { isDeclarationEnabled : '' ,isFormVisible:'', Declaration: '', FormName: '', NoDeclaration: '', remplir: '', Date: '', status: '' };
  submitResponse: any = "";
  formsStatus: string;
  NoDeclarationLink: any;
  isDataEntered = false;
  isUserAffiliate: boolean;
  formsDeclarationCachedData: any = [];
  formStatus : any = [];
  form1Status: any;
  form2Status: any;
  form3Status: any;
  form4Status: any;
  form5Status: any;
  form6Status: any;
  cachedDataFromSession: any;
  declarationData: any;
  dataXml: any;
  xmlFile: any;
  declaration: any;
  cachedForm1Data: any;
  cachedForm2Data: any;
  cachedForm4Data: any;
  cachedForm5Data: any;
  form1SubmissionDate: string;
  form2SubmissionDate: string;
  form4SubmissionDate: string;
  form5SubmissionDate: string;
  cached1DeclarationData: any;
  cached2DeclarationData: any;
  cached4DeclarationData: any;
  cached5DeclarationData: any;
  ListOfDeclaration = [

  ];
  form3SubmissionDate: string;
  SubmitDeclaration = {
    Header:
    {
                         QualCiv: "string",
                         Nom: "string",
                         Prenom: "string",
                         NoClient: 0,
                         NoIntervenant:0,
                         RegimeLinguistique: "",
                         Email: "string",
                         Rue: "string",
                         NoRue: "string",
                         CodePostal: 0,
                         Localite: "string",
                         LibellePays: "string",
    },
                  Declaration: []
                }
  isSubmitEnabled: boolean = false;
  clientsData: any;
  intervenantNo: any;
  FormsData: any;
  submitError: boolean;
  downloadError: boolean;
  filePath = environment.FilePath;

  constructor(public _router: Router, private translate: TranslateService,
    public _declarationService: DeclarationService, public sharingService: SharingService) {
  }

  ngOnInit() {
    this.FormsData = JSON.parse(sessionStorage.getItem("FormsData"));
    this.clientNo = sessionStorage.getItem("ClientNo");
    this.Year = sessionStorage.getItem("Year");
    this.Aff_check = sessionStorage.getItem("AFF_Check");
    this.clientsData = JSON.parse(sessionStorage.getItem("SelectedClientData"));
    this.intervenantNo = sessionStorage.getItem("NoIntervenant");
    var submitStatus = sessionStorage.getItem("SubmitStatus");
    if(submitStatus == "Success"){
      this.formsStatus = submitStatus;
    }
   
    if (this.ListOfDeclaration != undefined || null) {
     
      if (this.ListOfDeclaration != null) {
        this.cachedDataFromSession = this.ListOfDeclaration;
      }
      else {
        this.cachedDataFromSession = [];
      }
    }

    if (this.Aff_check != "_AF") {
      this.noIntervenant = sessionStorage.getItem("NoIntervenant");
      this.isUserAffiliate = false;
    } else {
      this.isUserAffiliate = true;
      this.noIntervenant = "0";
    }
    this.getDeclarationFormsData();
  }

  downloadPdf(Genre,NoDeclaration) {
 var pdfPath = this.filePath + "OnlineDeclarations_" + this.clientNo +'_'+ NoDeclaration + '_' + Genre + ".pdf";
     
   var obj ={ FilePath : pdfPath };
   this._declarationService.
   downloadPdfService(obj)
   .subscribe(
     (response) => {
      this.downloadError = false;
      if (!!response && response.length > 0) {
        var pdfBytes = JSON.parse(response);
      exportFile(pdfBytes.bytes, 'application/octet-stream', 'OnlineDeclarations_' + this.clientNo +'_'+ NoDeclaration +'_' + Genre, 'pdf');
      }else if(response == "Failed"){
        this.downloadError = true;
      }
      else{
        this.downloadError = true;
      }
     },
     (err) => { 
      this.downloadError = true;
     }
   );
  }
  submitFormsData(submitConfirmation) {
    if(submitConfirmation){
    this.isDataEntered = true;
    // var submitData = this.objectData;
    this.getHeaderData();
    this.SubmitDeclaration.Declaration = this.FormsData;

    // this.SubmitDeclaration.Declaration.forEach(element => {
    //   if(element.Genre == 'Z' || element.Genre == 'I' || element.Genre == 'O')
    //   {
    //     // if (element.Activite != null && element.Activite.length > 3) {

    //       //   let activityCount = element.Activite.length;
    //       let filterResultWithValues: any = element.Activite.filter(u => u != null);
    //       // filterResultWithValues = filterResultWithValues.filter(u => u.MontantNet != "0" || u.Pourcent != "0");

    //       // filterResultWithValues.forEach((activite,index) => {
    //       //   if(filterResultWithValues.length > 3) {
    //       //     filterResultWithValues.splice(index,1);
    //       //   }
    //       // });
    //       element.Activite = filterResultWithValues;
    //     // }
            
    //           // filterResultWithValues.forEach(element => {
    //           //   element.Activite.push(element);
    //           // });
              
    //     //   if(activityCount !== filterResultWithValues.length)
    //     //   {
    //     //       const activityWithBlanks = element.Activite.reduce((a, o) => (o != null && o.MontantNet == 0 && o.Pourcent == 0 && a.push(o.CodeActivite), a), [])  
    //     //       for (let activity of activityWithBlanks.slice().reverse()) {
    //     //         for (let elementArrayObject of element.Activite) {
    //     //           if (elementArrayObject != null && elementArrayObject.CodeActivite == activity) {
    //     //             if(element.Activite.length > 3)
    //     //             {
    //     //               element.Activite.splice(element.Activite.indexOf(elementArrayObject), 1);
    //     //             }
    //     //           }      
    //     //       }
    //     //     }
    //     //   }
         
    //   }
    // });
   
    this._declarationService.
      submitFormsDeclarationData(this.SubmitDeclaration)
      .subscribe(
        (response) => {
          this.submitResponse = response;
          if (this.submitResponse == "Success") {
            sessionStorage.setItem("SubmitStatus", this.submitResponse);
            this.formsStatus = sessionStorage.getItem("SubmitStatus");
            this.isSubmitEnabled = true;
            this.submitError = false;
            //window.location.reload();
            this.getDeclarationFormsData();
          }else{
            this.submitError = true;
          }
        },
        (err) => { 
          this.submitError = true;
        }
      );
    }
  }
  
  getDeclarationFormsData() {
    this.rowData = [];

    // this._declarationService.
    //getDeclarationMockupData() //comment this while pushing
    //    getFormsDeclarationData(clientNo, year,noIntervenant,languageInput) // uncomment while pushing
    // .subscribe(
    //   (resoponse) => {
    this.fomsData = JSON.parse(sessionStorage.getItem("FormsData"));
    
    this.getStatusFromCachedData();
    
    this.getSubmissionDate();
    
    if (this.fomsData) {
      
      this.fomsData.forEach(element => {
        var isFormEnable = "false";
        var isAffiliate ="true";
        if (element.noIntervenantDestinataire == this.intervenantNo) {
          isFormEnable = "true";
          
        }
        if(!this.isUserAffiliate ){
          if (element.noIntervenantDestinataire != this.intervenantNo) {
          isAffiliate = "false";
          }
        }
        if (element.Genre == "Z" ) {
          //   Z --> form 1
          //this.form1Data = element;
          this.objectData = {isDeclarationEnabled :isFormEnable ,isFormVisible : isAffiliate,  Declaration: 'Dashboard_OD0070', FormName: element.Genre, NoDeclaration: element.NoDeclaration, remplir: element.NomDestinataire, Date: element.LastModifiedDate, status: this.getFormStatus(element.Genre,element.NoDeclaration)};
          this.rowData.push(this.objectData)
        }
        else if (element.Genre == "I" ) {
          // I --> form 2
         
          //this.form2Data = element;
          this.objectData = {isDeclarationEnabled : isFormEnable,isFormVisible : isAffiliate, Declaration: 'Dashboard_OD0071', FormName: element.Genre, NoDeclaration: element.NoDeclaration, remplir: element.NomDestinataire, Date: element.LastModifiedDate, status: this.getFormStatus(element.Genre,element.NoDeclaration) };
          this.rowData.push(this.objectData)
        }
        else if (element.Genre == "C" ) {
          // C --> form 3
          //this.form3Data = element;
          this.objectData = {isDeclarationEnabled : isFormEnable,isFormVisible : isAffiliate, Declaration: 'Dashboard_OD0072', FormName: element.Genre, NoDeclaration: element.NoDeclaration, remplir: element.NomDestinataire, Date: element.LastModifiedDate, status: this.getFormStatus(element.Genre,element.NoDeclaration) };
          this.rowData.push(this.objectData)
        }
        else if (element.Genre == "O" ) {
          // O  --> form 4
          //this.form4Data = element;
          this.objectData = {isDeclarationEnabled : isFormEnable,isFormVisible : isAffiliate, Declaration: 'Dashboard_OD0073', FormName: element.Genre, NoDeclaration: element.NoDeclaration, remplir: element.NomDestinataire, Date: element.LastModifiedDate, status: this.getFormStatus(element.Genre,element.NoDeclaration) };
          this.rowData.push(this.objectData)
        }
        else if (element.Genre == "T" ) {
          // T  --> form 5 
          //this.form5Data = element;
          this.objectData = {isDeclarationEnabled : isFormEnable,isFormVisible : isAffiliate, Declaration: 'Dashboard_OD0074', FormName: element.Genre, NoDeclaration: element.NoDeclaration, remplir: element.NomDestinataire, Date: element.LastModifiedDate, status: this.getFormStatus(element.Genre,element.NoDeclaration) };
          this.rowData.push(this.objectData)
        }
        else if (element.Genre == "6") {
         // T  --> form 6 
         this.form6Data = element;
         this.objectData = {isDeclarationEnabled : isFormEnable,isFormVisible : isAffiliate, Declaration: 'Dashboard_OD0075', FormName: element.Genre, NoDeclaration: element.NoDeclaration, remplir: this.form6Data.NomDestinataire, Date: element.LastModifiedDate, status: this.getFormStatus(element.Genre,element.NoDeclaration) };
         this.rowData.push(this.objectData)
        }
        
      });
      
    }
    this.fomsData.forEach(element => {
        // if(element.Genre != "M" && element.Genre != "P" && element.Genre != "F"
        //     && element.Genre != "H" && element.Genre != "D" && element.Genre != "R") {
            if (element.Statut != "ACTIVE"  && element.noIntervenantDestinataire == this.intervenantNo) {
                this.isSubmitEnabled = true;
            }
            if(element.Statut == "Completed" && element.noIntervenantDestinataire == this.intervenantNo){
              this.formsStatus = "Success";
            }
          // }
    });

    
  }

  getFormStatus(genre,nodeclaration)
  {
     var filteredFormStatus = this.formStatus.filter(formstatus => formstatus.Genre === genre && formstatus.NoDeclaration === nodeclaration)[0];
     return filteredFormStatus.Status;
  }

  getStatusFromCachedData() {
    if (this.cachedDataFromSession !== undefined && this.cachedDataFromSession.length != 0) {
      this.formStatus = [];
      this.cachedDataFromSession.forEach(element => {
        if (element.Genre == "Z") {
          this.formStatus.push({"Genre":'Z',"NoDeclaration":element.NoDeclaration,"Status":this.assignDeclarationStatus(element.Statut)});
          //this.form1Status = this.assignDeclarationStatus(element.Statut);
        } else if (element.Genre == "I") {
          this.formStatus.push({"Genre":'I',"NoDeclaration":element.NoDeclaration,"Status":this.assignDeclarationStatus(element.Statut)});
         // this.form2Status = this.assignDeclarationStatus(element.Statut);
        } else if (element.Genre == "C") {
          this.formStatus.push({"Genre":'C',"NoDeclaration":element.NoDeclaration,"Status":this.assignDeclarationStatus(element.Statut)});
          //this.form3Status = this.assignDeclarationStatus(element.Statut);
        } else if (element.Genre == "O") {
          this.formStatus.push({"Genre":'O',"NoDeclaration":element.NoDeclaration,"Status":this.assignDeclarationStatus(element.Statut)});
          //this.form4Status = this.assignDeclarationStatus(element.Statut);
        } else if (element.Genre == "T") {
          this.formStatus.push({Genre:'T',"NoDeclaration":element.NoDeclaration,"Status":this.assignDeclarationStatus(element.Statut)});
          //this.form5Status = this.assignDeclarationStatus(element.Statut);
        }else if (element.Genre == "6") {
          this.formStatus.push({Genre:'6',"NoDeclaration":element.NoDeclaration,"Status":this.assignDeclarationStatus(element.Statut)});
          //this.form5Status = this.assignDeclarationStatus(element.Statut);
        }
      });
    } else {
      this.formStatus = [];
      this.fomsData.forEach(element => {
        var checkSubmitSuccess = false;
        if(this.formsStatus == "Success" && element.noIntervenantDestinataire == this.intervenantNo){
         checkSubmitSuccess = true;
        }
        if (element.Genre == "Z") {
          //this.form1Status = checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198";
          this.formStatus.push({"Genre":'Z',"NoDeclaration":element.NoDeclaration,"Status": checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198"});
        } else if (element.Genre == "I") {
          //this.form2Status = checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198";
          this.formStatus.push({"Genre":'I',"NoDeclaration":element.NoDeclaration,"Status": checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198"});
        } else if (element.Genre == "C") {
          //this.form3Status = checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198";
          this.formStatus.push({"Genre":'C',"NoDeclaration":element.NoDeclaration,"Status": checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198"});
        } else if (element.Genre == "O") {
          //this.form4Status = checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198";
          this.formStatus.push({"Genre":'O',"NoDeclaration":element.NoDeclaration,"Status": checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198"});
        } else if (element.Genre == "T") {
          //this.form5Status = checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198";
          this.formStatus.push({"Genre":'T',"NoDeclaration":element.NoDeclaration,"Status": checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198"});
        } else if (element.Genre == "6") {
          //this.form5Status = checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198";
          this.formStatus.push({"Genre":'6',"NoDeclaration":element.NoDeclaration,"Status": checkSubmitSuccess != true ? this.assignDeclarationStatus(element.Statut) : "dashboard_form_status_OD0198"});
        } 
      
      });
       }
  }
  getHeaderData(){
    this.SubmitDeclaration.Header.NoClient = parseInt(sessionStorage.getItem('ClientNo'));
    this.SubmitDeclaration.Header.NoIntervenant = Number(sessionStorage.getItem("NoIntervenant"));
    this.SubmitDeclaration.Header.Email = sessionStorage.getItem('NewEmail') != null ? sessionStorage.getItem('NewEmail'):sessionStorage.getItem('Email');
    this.SubmitDeclaration.Header.CodePostal = this.clientsData.CodePostal;
    this.SubmitDeclaration.Header.LibellePays = this.clientsData.LibellePays;
    this.SubmitDeclaration.Header.Localite = this.clientsData.Localite;
    this.SubmitDeclaration.Header.Rue = this.clientsData.Rue;
    this.SubmitDeclaration.Header.NoRue = this.clientsData.NoRue;
    this.SubmitDeclaration.Header.QualCiv = this.clientsData.QualCiv;
    this.SubmitDeclaration.Header.RegimeLinguistique = this.clientsData.RegimeLinguistique;
    this.SubmitDeclaration.Header.Nom = this.clientsData.Nom;
    this.SubmitDeclaration.Header.Prenom = this.clientsData.Prenom;
  }
  getSubmissionDate() {
    this.form1SubmissionDate = sessionStorage.getItem('form1SubmittedDate') == null ? "" : sessionStorage.getItem('form1SubmittedDate');
    this.form2SubmissionDate = sessionStorage.getItem('form2SubmittedDate') == null ? "" : sessionStorage.getItem('form2SubmittedDate');
    this.form3SubmissionDate = sessionStorage.getItem('form3SubmittedDate') == null ? "" : sessionStorage.getItem('form3SubmittedDate');
    this.form4SubmissionDate = sessionStorage.getItem('form4SubmittedDate') == null ? "" : sessionStorage.getItem('form4SubmittedDate');
    this.form5SubmissionDate = sessionStorage.getItem('form5SubmittedDate') == null ? "" : sessionStorage.getItem('form5SubmittedDate');
  }

  assignDeclarationStatus(status) {
    var currentFormStatus;
    // if(this.formsStatus == "Success" && element.noIntervenantDestinataire == this.intervenantNo){
    //   currentFormStatus = "dashboard_form_status_OD0198";
    // }else{
    if (status == ("")) {
      currentFormStatus = "dashboard_form_status_OD0196";
    } else if (status == ("NEW")) {
      currentFormStatus = "dashboard_form_status_OD0196";
    } else if (status == "ACTIVE") {
      currentFormStatus = "dashboard_form_status_OD0197";
    } else if (status == "Completed") {
      currentFormStatus = "dashboard_form_status_OD0198";
    }
  //  }
    return currentFormStatus;
  }

  redirectToForms(formsdata,nodeclaration) {
    let selectedForm = this.FormsData.filter(formdata => formdata.NoDeclaration === nodeclaration)[0];
    if (selectedForm) {
      this.sharingService.setFormsData(selectedForm);
      sessionStorage.setItem("selectedFormData", JSON.stringify(selectedForm));
    }
    if (formsdata[15] === "0") {
      this._router.navigate(['/form1']);
    }
    else if (formsdata[15] === "1") {
      this._router.navigate(['/form2']);
    }
    else if (formsdata[15] === "2") {
      this._router.navigate(['/form3']);
    }
    else if (formsdata[15] === "3") {
      this._router.navigate(['/form4']);
    }
    else if (formsdata[15] === "4") {
      this._router.navigate(['/form5']);
    }
    else if (formsdata[15] === "5") {
      this._router.navigate(['/form6']);
    }
  }

  ngOnDestroy(): void {
    //  sessionStorage.removeItem("ClientNo");
    //    sessionStorage.removeItem("Year");
    //    sessionStorage.removeItem("ClientName");

    //    location.reload();
    //   this.fomsData = [];
    //   this.form1Data = "";
    //   this.form2Data = "";
    //   this.form3Data = "";
    //   this.form4Data = "";
    //   this.form5Data = "";
  }

}
